import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import { Tables } from '@/integrations/supabase/types';
import { captureSentryException } from '@/integrations/sentry/client';

export type InvestmentTransactionDetail = Tables<'investment_transactions'> & {
  investment_accounts: Pick<Tables<'investment_accounts'>, 'id' | 'fund_name' | 'fund_manager' | 'balance' | 'currency' | 'investment_type_id' | 'account_number'> | null;
  categories: Pick<Tables<'categories'>, 'name' | 'icon'> | null;
};

export function useInvestmentTransactionDetail(id: string) {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['investment-transaction-detail', id, user?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('investment_transactions')
        .select('*, investment_accounts(id, fund_name, fund_manager, balance, starting_amount, currency, investment_type_id, account_number), categories(name, icon)')
        .eq('id', id)
        .eq('user_id', user!.id)
        .single();

      if (error?.code === 'PGRST116') throw new Error('Transaction not found');
      if (error) {
        captureSentryException(error);
        throw error;
      }

      return data as unknown as InvestmentTransactionDetail;
    },
    staleTime: 86_400_000,
    gcTime: 86_400_000,
    enabled: !!user && !!id,
  });
}
